import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Carousel } from "react-carousel-minimal";
import ReactImageZoom from "react-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import InnerImageZoom from "react-inner-image-zoom";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function Gallery({ imgs }) {
  const [type, setType] = useState("image");
  const [selected, setSelected] = useState(null);
  const [index, setIndex] = useState(0);

  console.log("selected", selected);
  console.log("type", type);
  console.log("index", index);

  useEffect(() => {
    setSelected(imgs[0].image);
  }, [imgs]);

  const changeType = (src, typeToEnter, idx) => {
    setSelected(src);
    setType(typeToEnter);
    setIndex(idx);
  };
  const goToPrevImage = () => {
    if (index > 0) {
      if (imgs[index - 1]?.video === undefined) {
        changeType(imgs[index - 1].image, "image", index - 1);
      } else {
        changeType(imgs[index - 1].video, "video", index - 1);
      }
    } else {
      if (imgs[imgs.length - 1]?.video === undefined) {
        changeType(imgs[imgs.length - 1].image, "image", imgs.length - 1);
      } else {
        changeType(imgs[imgs.length - 1].video, "video", imgs.length - 1);
      }
    }
  };
  const goToNextImage = () => {
    if (index < imgs.length - 1) {
      if (imgs[index + 1]?.video === undefined) {
        changeType(imgs[index + 1].image, "image", index + 1);
      } else {
        changeType(imgs[index + 1].video, "video", index + 1);
      }
    } else {
      if (imgs[0]?.video === undefined) {
        changeType(imgs[0].image, "image", 0);
      } else {
        changeType(imgs[0].video, "video", 0);
      }
    }
  };
  return (
    <Box className="App">
      <Box
        sx={{
          textAlign: "center",
          position: "relative",
          left: { md: "-60px", sm: "+20px", xs: "+30px" },
          pt: 6,
          // border: "1px solid black",
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "500px", height: "490px", overflow: "hidden" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box>
              <ChevronLeftIcon
                sx={{
                  position: "relative",
                  left: "+30px",
                  zIndex: 1000,
                  fontSize: "32px",
                  cursor: "pointer",
                }}
                onClick={goToPrevImage}
              />
            </Box>
            {type === "image" ? (
              <InnerImageZoom
                width={440}
                height={450}
                src={selected}
                zoomSrc={selected}
                zoomType="hover"
                zoomPreload={true}
              />
            ) : (
              <>
                {/* http://www.get-youtube-thumbnail.com/ */}
                <iframe
                  width={440}
                  height={450}
                  src={selected + "?autoplay=1"}
                  title="Heslet"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </>
            )}
            <Box>
              <ChevronRightIcon
                sx={{
                  position: "relative",
                  left: "-30px",
                  zIndex: 1000,
                  fontSize: "32px",
                  cursor: "pointer",
                }}
                onClick={goToNextImage}
              />
            </Box>
          </Box>
          <Box sx={{ fontSize: "11px", color: "gray", pt: "2px", pb: 1 }}>
            <ZoomInIcon
              sx={{ fontSize: "13px", position: "relative", top: "+2px" }}
            />{" "}
            마우스 오버시 더 자세히 보실수 있습니다
          </Box>
          {/* <img src={selected} width="370" height="370" /> */}
        </Box>
        <Box sx={{ overflow: "hidden", width: "450px" }}>
          <Box sx={{ px: 2, display: "flex", alignItems: "center" }}>
            <Box sx={{ display: "flex", px: 2 }}>
              {imgs.map((img, idx) => {
                if (img.image) {
                  return (
                    <Box key={idx} sx={{ pr: 1 }}>
                      <img
                        src={img.image}
                        width="40"
                        height="40"
                        onClick={(e) => changeType(img.image, "image", idx)}
                        style={{ cursor: "pointer" }}
                      />
                    </Box>
                  );
                } else {
                  return (
                    <Box>
                      <img
                        onClick={(e) => changeType(img.video, "video", idx)}
                        width="40"
                        height="40"
                        style={{ cursor: "pointer" }}
                        src={img.thumbnail}
                      />
                      {/* <iframe
                        onClick={(e) => changeType(img.video, "video")}
                        height="480"
                        width="500"
                        src={img}
                      ></iframe> */}
                    </Box>
                  );
                }
              })}
            </Box>
          </Box>
        </Box>
        {/* <Carousel
          showArrows={true}
          data={data}
          time={20000}
          width="360px"
          height="380px"
          captionStyle={captionStyle}
          radius="none"
          // slideNumber={true}
          slideNumberStyle={slideNumberStyle}
          captionPosition="bottom"
          automatic={true}
          dots={true}
          pauseIconColor="black"
          pauseIconSize="40px"
          slideBackgroundColor="white"
          slideImageFit="cover"
          thumbnails={true}
          thumbnailWidth="60px"
          style={{
            textAlign: "center",
            maxWidth: "850px",
            maxHeight: "500px",
            margin: "40px auto",
            position: "relative",
          }}
        /> */}
      </Box>
    </Box>
  );
}

export default Gallery;
